// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"1216":"vendors","2143":"app"}[chunkId] || chunkId) + ".css";
};